module.exports = "<li ng-class=\"{'gw-active': active, disabled: disabled}\" ng-click=\"select()\">\n    <a tab-heading-transclude>{{heading}}</a>\n</li>"